<template>
  <div class="panel"
       v-loading="listLoading">
    <el-button type="primary"
               icon="el-icon-close"
               size="mini"
               class="close"
               @click="close"
               circle></el-button>
    <myScroll style="width:100%;height:100%">
      <div class="panel-content">
        <div class="title">
          <span v-if="roomDetail&&roomDetail.room&&roomDetail.room.isStairway">
            <div style="display: inline-flex; justify-content: space-between; align-items: center;">
              <el-popover placement="left"
                          width="450"
                          trigger="click">
                <div class="stairway-info">
                  <div class="stairway">
                    <div class="stairway-title"><b>Stairway</b></div>
                    <div class="item">
                      <span class="label">Duplication</span>
                      <span class="content">{{roomDetail.room.stairway.duplication}}</span>
                    </div>
                    <div class="item">
                      <span class="label">Covering Style</span>
                      <span class="content">{{roomDetail.room.stairway.coveringStyle}}</span>
                    </div>
                    <div class="item">
                      <span class="label">Extra Top Rise</span>
                      <span class="content">
                        <el-checkbox :value="roomDetail.room.stairway.extraTopRise"
                                     disabled></el-checkbox>
                      </span>
                    </div>
                    <div class="item">
                      <span class="label">Step Per Break</span>
                      <span class="content">{{roomDetail.room.stairway.stepPerBreak}}</span>
                    </div>
                    <div class="item">
                      <span class="label">Left Stringer</span>
                      <span class="content">{{roomDetail.room.stairway.leftStringer}}</span>
                    </div>
                    <div class="item">
                      <span class="label">Right Stringer</span>
                      <span class="content">{{roomDetail.room.stairway.rightStringer}}</span>
                    </div>
                    <div class="item">
                      <span class="label">Left Stringer Product</span>
                      <span class="content">
                        <div v-for="product in roomDetail.room.stairway.leftStringerProducts"
                             :key="product.id">
                          <span>{{product.id}}</span>
                        </div>
                      </span>
                    </div>
                    <div class="item">
                      <span class="label">Right Stringer Product</span>
                      <span class="content">
                        <div v-for="product in roomDetail.room.stairway.rightStringerProducts"
                             :key="product.id">
                          <span>{{product.id}}</span>
                        </div>
                      </span>
                    </div>
                  </div>
                  <br>
                  <div class="stairUnit"
                       v-if="false">
                    <div class="stairway-title"><b>Stair Unit</b></div>
                    <div class="item">
                      <span class="label">Turns Left</span>
                      <span class="content">
                        <el-checkbox :value="roomDetail.room.stairUnit.turnsLeft"
                                     disabled></el-checkbox>
                      </span>
                    </div>
                    <div class="item">
                      <span class="label">Step</span>
                      <span class="content">
                        {{roomDetail.room.stairUnit.step}}
                      </span>
                    </div>
                    <div class="item">
                      <span class="label">Stair Width</span>
                      <span class="content">
                        {{roomDetail.room.stairUnit.stairWidth}}
                      </span>
                    </div>
                    <div class="item">
                      <span class="label">Tread Width</span>
                      <span class="content">
                        {{roomDetail.room.stairUnit.treadWidth}}
                      </span>
                    </div>
                    <div class="item">
                      <span class="label">Nosing</span>
                      <span class="content">
                        {{roomDetail.room.stairUnit.nosing}}
                      </span>
                    </div>
                    <div class="item">
                      <span class="label">Rise Height</span>
                      <span class="content">
                        {{roomDetail.room.stairUnit.riseHeight}}
                      </span>
                    </div>
                    <div class="item">
                      <span class="label">Step Thickness</span>
                      <span class="content">
                        {{roomDetail.room.stairUnit.stepThickness}}
                      </span>
                    </div>
                  </div>
                </div>
                <span slot="reference"
                      class="hoverable">
                  <h3><label>{{roomDetail.room.name}}</label> <i class="el-icon-info"></i></h3>
                  <span v-if="false">Width: {{roomDetail.room.stairUnit.stairWidth}}, Thread: {{roomDetail.room.stairUnit.treadWidth}}, Steps: {{roomDetail.room.stairUnit.step}}</span>
                </span>
              </el-popover>
              <span @click="handleClickViewPhotos"
                    v-loading="roomPhotosLoading">
                <el-badge :value="roomPhotosCount"
                          :class="roomPhotosCount>0?'hoverable':''"
                          class="photo-badge"
                          :type="roomPhotosCount>0?'primary':'info'">
                  <i class="el-icon-picture"></i>
                </el-badge>
              </span>
            </div>
          </span>
          <span v-else>
            <div style="display:flex; align-items:center;">
              <h3>{{roomDetail&&roomDetail.room ? roomDetail.room.name:''}}</h3>
              <span @click="handleClickViewPhotos"
                    v-loading="roomPhotosLoading">
                <el-badge :value="roomPhotosCount"
                          :class="roomPhotosCount>0?'hoverable':''"
                          class="photo-badge"
                          :type="roomPhotosCount>0?'primary':'info'">
                  <i class="el-icon-picture"></i>
                </el-badge>
              </span>
            </div>
            <span>{{roomDetail&&roomDetail.room ?roomDetail.room.area:''}}, {{ roomDetail&&roomDetail.room ? roomDetail.room.len:''}}</span>
          </span>
        </div>
        <el-dropdown @command="openAddTask">
          <span class="el-dropdown-link">
            <el-button class="add"
                       v-has="'Add Task'"
                       slot="reference"
                       type="primary">
              {{$t('model.AddTask')}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">{{$t('model.Task')}}</el-dropdown-item>
            <el-dropdown-item command="1">{{$t('model.ProductInstallation')}}</el-dropdown-item>
            <el-dropdown-item command="2">{{$t('model.Moisture')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="product-box">
          <el-form label-position="top"
                   v-if="children.length > 0">
            <div v-for="i in children"
                 :key="i.type">
              <el-form-item :label="i.existTasks ? i.Name + ' ' + (i.rate ?i.rate:'0')+'%': i.Name "
                            class="tem">
                <InputRadioSelectPopover v-if="i.existTasks"
                                         v-model="i.rate"
                                         :disabled="disableUpdate"
                                         :btnStyle="0"
                                         @change="changeCompletionRate(i.list,1,i.rate)">
                </InputRadioSelectPopover>
                <el-table size="mini"
                          class="product-table"
                          :data="i.list"
                          :show-header="false">
                  <el-table-column>
                    <template slot-scope="scope">
                      <ProductInfo v-model="scope.row.CompletionRate"
                                   :product="scope.row"
                                   :disableInputRadioSelect="disableUpdate"
                                   @changeCompletionRate="changeCompletionRate(scope.row,2,scope.row.CompletionRate)"></ProductInfo>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="task-box"
             v-if="list.length>0">
          <div class="task-title">
            <span>
              {{$t('model.Tasks')}}
            </span>
            <el-button size="mini"
                       type="primary"
                       :disabled="disableUpdate"
                       @click="markAsDown">{{$t('model.MarkAsDone')}}</el-button>
          </div>
          <div class="list-box">
            <el-table :border="false"
                      @row-click="showTaskDialog"
                      :show-header="false"
                      style="width:99%"
                      :data="list">
              <el-table-column>
                <template slot-scope="scope">
                  <div class="flex-container">
                    <svg-icon :iconClass="scope.row.icon"
                              :class="scope.row.color"></svg-icon>
                    <div class="table-text">
                      <span :class="scope.row.color!== 'Danger'?'':'Danger'"
                            class="text text-left">
                        {{scope.row.Name}}
                      </span>
                      <span class="text completionRate text-right"
                            v-if="scope.row.TaskType !== 2">
                        {{scope.row.CompletionRate}}%
                      </span>
                      <span v-if="scope.row.Concrete"
                            class="text completionRate text-right"> {{$t('task.Concrete')}}:{{scope.row.Concrete}}%</span>
                      <span class="text text-small text-left"
                            v-if="!scope.row.AssignedUserNames">{{scope.row.TaskPhaseName}}</span>
                      <span class="text text-small text-left"
                            v-if="scope.row.AssignedUserNames">{{scope.row.AssignedUserNames}} {{scope.row.TaskPhaseName ? "("+scope.row.TaskPhaseName+")":""}}</span>
                      <span class="text text-small text-right">{{scope.row.EndDate?scope.row.EndDate.substring(0,10): ''}}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </myScroll>
  </div>
</template>

<script>
import { getTasksList, getChildren, changeChild, getTaskById } from '@/api/config'
import InputRadioSelectPopover from '@components/common/InputRadioSelectPopover'
import ProductInfo from '@components/common/ProductInfo'
import { mapState } from 'vuex'
import _ from 'lodash'
import Vue from 'vue'
import axios from 'axios'
import imageViewer from 'vue-image-viewer'
Vue.use(imageViewer)
export default {
  data () {
    return {
      condition: {
        PageIndex: 1,
        PageSize: 1000,
        // GetChildTask: ,
        GetRecycle: false,
        IsApp: false,
        OrderBy: 'LastUpdatedOn desc',
        RoomId: ''
      },
      list: [],
      listLoading: false,
      disableUpdate: false,
      children: [],
      hasRoomPhotos: false,
      roomPhotosCount: 0,
      roomPhotosLoading: false,
      getRoomPhotosRequest: null
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'plan', 'mockUserInfo']),
    tasksProgressOptions () {
      return this.$store.state.diag.data.tasksProgressOptions
    },
    roomDetail () {
      return this.$store.state.diag.data.roomDetail
    },
    roomId () {
      return this.$route.params.roomId
    }
  },
  mounted () {
    this.init()
    this.getRoomTaskList()
    this.initRoomPhotos()
  },
  watch: {
    roomDetail (to, from) {
      if (to.room) {
        this.children = []
        this.init()
        this.getRoomTaskList()
        this.initRoomPhotos()
      }
    }
  },
  methods: {
    init () {
      if (this.mockUserInfo && this.mockUserInfo.UserId) {
        this.disableUpdate = true
      }
      let assignType = []
      if (this.roomDetail && this.roomDetail.products) {
        for (let i = 0; i < this.roomDetail.products.length; i++) {
          assignType.push(this.roomDetail.products[i].TaskAssignType)
        }
        assignType = this.$config.arrUnique(assignType)
        for (let j = 0; j < assignType.length; j++) {
          let obj = {
            type: assignType[j],
            Name: this.getTaskAssignTypeName(assignType[j]),
            list: [],
            existTasks: false,
            rate: 0
          }
          this.children.push(obj)
        }
        this.children = this.$config.sortArray(this.children, 'type', 'asc')
        for (let m of this.children) {
          for (let n of this.roomDetail.products) {
            n.Color = this.$config.colorRGB2Hex(n.color)
            if (n.TaskAssignType === m.type) {
              m.list.push(n)
            }
          }
        }
      }
    },
    openAddTask (command) {
      let arr = []
      arr.push(this.roomDetail.room)
      this.$store.commit('diag/setAddRoomList', arr)
      this.$store.commit('diag/setAddTaskType', command)
      this.$store.commit('diag/openAddTaskDialog', true)
    },
    showTaskDialog (row) {
      let point = {
        x: row.LocationX,
        y: row.LocationY
      }
      this.$store.commit('diag/setSelectPoint', point)
      let routername = 'modelTask'
      this.$router.push({
        name: routername,
        params: {
          id: row.TaskId
        }
      })
    },
    getTaskAssignTypeName (type) {
      let name
      switch (type) {
        case 0:
          name = this.$t('model.Floor')
          break
        case 1:
          name = this.$t('model.Wall')
          break
        case 2:
          name = this.$t('model.Base/LF')
          break
        case 3:
          name = this.$t('model.Door')
          break
      }
      return name
    },
    getRoomTaskList () {
      this.list = []
      this.listLoading = true
      this.condition.RoomId = this.roomId
      this.condition.JobsiteId = this.jobsiteID
      this.condition.PlanId = this.plan.PlanId
      getTasksList(this.condition).then(res => {
        this.list = this.$config.handleTaskList(res.Data)
        getChildren(this.condition).then(async item => {
          for (let i of item.Data) {
            i.Product = await this.$config.handleProduct(i.TaskProduct, i.TaskShapes)
            let totalQty = i.Product.NetArea ? i.Product.transformNetArea : i.Product.transformTotal
            i.Product.transformInstallQty = this.$config.numberFormat(this.$config.getFormatNumber(totalQty * i.CompletionRate / 100, 2))
            if (i.TaskProduct.Unit === 10) {
              i.Product.transformInstallQty = Math.ceil(i.Product.transformInstallQty)
            }
          }
          let children = []
          for (let i of this.list) {
            for (let j of item.Data) {
              if (i.TaskId === j.ParentTaskId) {
                children.push(j)
              }
            }
          }
          for (let k of this.children) {
            let total = 0
            let length = 0
            let existTasks = false
            for (let x of k.list) {
              this.$set(x, 'Product', {})
              x.taskIdList = []
              x.ParentTaskIdList = []
              if (children.length > 0) {
                for (let y of children) {
                  if (x.id === y.TaskProduct.SKU && x.TaskAssignType === y.AssignType) {
                    this.$set(x, 'Product', _.cloneDeep(y.Product))
                    this.$set(x, 'CompletionRate', y.CompletionRate)
                    this.$set(x, 'Unit', y.TaskProduct.Unit)
                    x.taskIdList.push(y.TaskId)
                    x.ParentTaskIdList.push(y.ParentTaskId)
                    existTasks = true
                  }
                }
                x.CompletionRate = x.CompletionRate || 0
                let com = x.CompletionRate * x.taskIdList.length
                total += com
                length += x.taskIdList.length
              }
              this.$set(x, 'showInputRadioSelect', x.taskIdList && x.taskIdList.length > 0)
            }
            let rate = this.$config.getFormatNumber(total / length)
            this.$set(k, 'rate', rate)
            this.$set(k, 'existTasks', existTasks)
          }
          this.listLoading = false
        })
      })
      for (let i of this.children) {
        i.list = this.$config.arrUnique(i.list, 'id')
        for (let obj of i.list) {
          var unitNum = this.$config.getUnit(obj.unit)
          var typeNum = this.$config.getProductNum(obj.type)
          obj.transformUsage = this.$config.transformUnit(obj.usage, unitNum, typeNum).num
          obj.transformNetArea = this.$config.transformUnit(obj.netArea, unitNum, typeNum).num
          obj.NetArea = obj.transformNetArea
          console.log(obj)
        }
      }
    },
    close () {
      let routername = 'taskList'
      this.$router.push({
        name: routername
      })
    },
    async changeCompletionRate (list, type, rate) {
      this.listLoading = true
      // 1 一组材料 2 单个材料
      let fatherIdList = []
      let childIdList = []
      if (type === 1) {
        list.forEach(res => {
          res.ParentTaskIdList.forEach(ele => {
            fatherIdList.push(ele)
          })
          res.taskIdList.forEach(item => {
            childIdList.push(item)
          })
        })
      }
      if (type === 2) {
        list.ParentTaskIdList.forEach(ele => {
          fatherIdList.push(ele)
        })
        list.taskIdList.forEach(item => {
          childIdList.push(item)
        })
      }
      let param = []
      childIdList.forEach(res => {
        let taskCompletionRate = {
          TaskId: res,
          CompletionRate: rate,
          Status: 'Completed'
        }
        param.push(taskCompletionRate)
      })
      fatherIdList = this.$config.arrUnique(fatherIdList)
      await this.changeChild(param).then(res => {
        this.changeFatherTask(fatherIdList).then(ele => {
          this.changeChild(ele).then(ele => {
            this.getRoomTaskList()
            this.$store.dispatch('diag/getTasksList')
          })
        })
      })
    },
    changeChild (list) {
      return new Promise((resolve, reject) => {
        changeChild(list).then(res => {
          resolve(true)
        })
      })
    },
    changeFatherTask (list) {
      return new Promise(async (resolve, reject) => {
        let arr = []
        for (let item of list) {
          let taskCompletionRate = {
            TaskId: '',
            CompletionRate: 0,
            Status: 'Completed'
          }
          taskCompletionRate.TaskId = item
          await this.getTaskById(item, 1).then(ele => {
            taskCompletionRate.CompletionRate = ele
            if (ele === 100) {
              taskCompletionRate.Status = 'Completed'
            } else {
              taskCompletionRate.Status = 'Open'
            }
            arr.push(taskCompletionRate)
          })
        }
        resolve(arr)
      })
    },
    getTaskById (id, type) {
      return new Promise((resolve, reject) => {
        getTaskById(id).then(res => {
          let length = 0
          let total = 0
          res.TaskChildens.forEach(ele => {
            length += 1
            total += ele.CompletionRate
          })
          let CompletionRate = total / length
          if (type === 1) {
            resolve(CompletionRate)
          } else {
            resolve(res)
          }
        })
      })
    },
    async markAsDown () {
      this.listLoading = true
      for (let i of this.list) {
        // ignore moisture task
        if (i.TaskType === 0 || i.TaskType === 1 || i.TaskType === 4) {
          let arr = []
          let taskCompletionRate = {
            TaskId: i.TaskId,
            CompletionRate: 100,
            Status: 'Completed',
            CompletionDate: this.$config.UTCTime(null, true)
          }
          arr.push(taskCompletionRate)
          if (i.TaskType === 4) {
            let task = await this.getTaskById(i.TaskId, 2)
            task.TaskChildens.forEach(res => {
              let taskCompletionRate = {
                TaskId: res.TaskId,
                CompletionRate: 100,
                Status: 'Completed',
                CompletionDate: this.$config.UTCTime(null, true)
              }
              arr.push(taskCompletionRate)
            })
          }
          changeChild(arr).then(res => {
            this.getRoomTaskList()
            this.$store.dispatch('diag/getTasksList')
          })
        }
      }
    },
    handleClickViewPhotos () {
      if (!this.hasRoomPhotos) {
        return
      }
      if (this.imageViewIsDisplay()) {
        this.$imageViewer.hide()
      } else {
        if (this.hasRoomPhotos) {
          // this.$imageViewer.index(0)
          let config = {
            config: {
              imgMaxWidth: window.innerWidth * 0.4,
              imgMaxHeight: window.innerHeight * 0.4,
              fullScreen: false
            },
            page: 0,
            index: 0
          }
          this.$imageViewer.show(config)
          this.$nextTick(() => {
            document.querySelector('.image-viewer-nav-thumb').width = document.querySelector('.image-viewer-nav-thumb').offsetWidth
            document.querySelector('.image-viewer-nav-thumb > div:first-child').style.marginLeft = ''
          })
        }
      }
    },
    imageViewIsDisplay () {
      return document.getElementsByClassName('image-viewer')[0].style.display.toLowerCase() !== 'none'
    },
    initRoomPhotos () {
      if (this.getRoomPhotosRequest) {
        this.getRoomPhotosRequest.cancel()
      }
      this.hasRoomPhotos = false
      this.roomPhotosCount = 0
      this.$imageViewer.hide()
      this.roomPhotosLoading = true
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
        'Authorization': 'Bearer ' + this.$store.state.userInfo.Token
      }
      const cancelToken = axios.CancelToken.source()
      this.getRoomPhotosRequest = cancelToken
      axios.get(this.getRoomPhotosUrl(), {
        params: null,
        headers: headers,
        cancelToken: cancelToken.token
      }).then(res => {
        if (res && res.length > 0) {
          let images = res.map(({ Description, FileName }) => ({ 'name': Description, 'url': this.getRoomPhotoUrl(FileName) }))
          this.$imageViewer.images(images)
          this.hasRoomPhotos = true
          this.roomPhotosCount = images.length
        }
      }).catch(error => {
        if (!axios.isCancel(error)) {
          console.error(error)
        }
      }).finally(() => {
        this.roomPhotosLoading = false
      })
    },
    getRoomPhotoUrl (photoName) {
      return this.$config.baseURL + '/api/Plans/' + this.plan.PlanId + '/Room/' + this.roomId + '/Photo/' + photoName
    },
    getRoomPhotosUrl () {
      return this.$config.baseURL + '/api/Plans/' + this.plan.PlanId + '/Room/' + this.roomId + '/Photos'
    }
  },
  beforeDestroy () {
    if (this.getRoomPhotosRequest) {
      this.getRoomPhotosRequest.cancel()
    }
  },
  destroyed () {
    this.$imageViewer.hide()
    console.log('destroyed roomPanel')
  },
  components: {
    InputRadioSelectPopover,
    ProductInfo
  }
}
</script>
<style lang="scss">
.el-radio-group {
  width: 100%;
  .el-radio {
    display: block !important;
    width: 100%;
    height: 30px;
    line-height: 30px;
    .el-radio__input {
      display: none;
    }
    &.is-checked {
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 20px;
        width: 20px;
        background-image: url("../../assets/image/check.png");
        color: #4193f6;
        background-size: 100%;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
<style scoped lang='scss'>
.panel {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  .close {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 100;
  }
  .panel-content {
    width: 95%;
    margin: 0 auto;
    overflow: hidden;
    .hoverable {
      cursor: pointer;
    }
    .title {
      width: 100%;
      border-bottom: 1px solid #dcdfe6;
      overflow: hidden;
      padding-bottom: 10px;
      margin-bottom: 10px;
      i {
        color: #999;
      }
    }
    .add {
      margin-bottom: 10px;
    }
    .product-box {
      margin-bottom: 20px;
      margin-top: 20px;
      .product-table {
        .name {
          color: #303133;
          font-weight: 600;
          display: inline-block;
          cursor: pointer;
          i {
            color: #999;
          }
        }
        .text-cube {
          position: relative;
          width: 100%;
          height: 60px;
          padding-left: 70px;
          .product-cube {
            width: 54px;
            height: 54px;
            position: absolute;
            left: 3px;
            top: 3px;
            border-radius: 5px;
          }
          .rate {
            position: absolute;
            font-size: 22px;
            right: 7%;
            top: 50%;
            transform: translateY(-50%);
            color: #4193f6;
          }
          .text {
            color: #303133;
            line-height: 20px;
            display: block;
            .label {
              display: inline-block;
              width: 55px;
            }
          }
          .completionRatePopover {
            position: absolute;
            top: 10px;
            right: 5px;
          }
        }
      }
    }
    .task-box {
      .task-title {
        width: 100%;
        margin-bottom: 15px;
        display: flex;
        height: 30px;
        line-height: 30px;
        align-items: center;
        justify-content: space-between;
      }
      .list-box {
        width: 100%;
        height: calc(100% - 36px);
        position: relative;
        .flex-container {
          display: flex;
          align-items: center;
          .table-text {
            flex: 1;
            width: 0;
            height: 46px;
            .text {
              line-height: 18px;
              overflow: hidden;
              display: block;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: inline-block;
            }
            .text-left {
              width: 65%;
            }
            .text-right {
              text-align: right;
              width: 32%;
            }
            .text-small {
              font-size: 13px;
              color: #666;
            }
            .completionRate {
              font-size: 16px;
              color: #4193f6;
            }
          }
        }

        .table-icon {
          width: 24px;
        }
        .svg-icon {
          font-size: 36px;
          margin-right: 14px;
        }
      }
    }
    .h3 {
      display: block;
      font-size: 1.17em;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      font-weight: bold;
    }
  }
}
.product-info {
  .item {
    display: flex;
    .label {
      display: inline-block;
      border: 1px solid #ccc;
      background: #eee;
      width: 88px;
      text-align: right;
      padding: 5px;
    }
    .content {
      display: inline-block;
      border: 1px solid #ccc;
      border-left: none;
      flex: 1;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding: 5px;
    }
  }
}

.stairway-info {
  .stairway-title {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .item {
    display: flex;
    .label {
      display: inline-block;
      border: 1px solid #ccc;
      background: #eee;
      flex: 1;
      text-align: right;
      padding: 5px;
    }
    .content {
      display: inline-block;
      border: 1px solid #ccc;
      border-left: none;
      flex: 1;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding: 5px;
    }
  }
}

.photo-badge {
  margin-left: 5px;
  i {
    font-size: 22px;
  }
  /deep/.el-badge__content {
    height: 16px;
    line-height: 16px;
    padding: 0 4px;
  }
  .hoverable {
    /deep/.el-badge__content {
      cursor: pointer;
    }
  }
}
</style>
